import React from 'react'

import { TeamCountSection, TeamCountDescription } from './styledComponents'

type Props = {
  teamCountContent: string
}

class TeamCount extends React.Component<Props> {
  render() {
    const { teamCountContent } = this.props
    return (
      <TeamCountSection>
        <TeamCountDescription as="p">{teamCountContent}</TeamCountDescription>
      </TeamCountSection>
    )
  }
}

export default TeamCount



// WEBPACK FOOTER //
// ./src/components/TeamNew/TeamProfiles/TeamCount.js